import type { ProductConfig } from '../../default/product/product.types';
import type { DeepPartial } from '../../default/types';

export const productConfig: DeepPartial<ProductConfig> = {
  cliplister: {
    customerId: '81856',
  },
  hasKIM: false,
  price: {
    showDiscountFlag: false,
  },
  recommendations: {
    dv: {
      slots: {
        1: 'searchProductToProducts',
        4: 'searchReplace',
      },
    },
    atb: {
      slots: {
        1: 'searchBasketToProducts',
        2: null,
      },
    },
  },
  serviceLayer: {
    paymentMethods: 'additional_infos_payment_methods',
  },
  powerSupply: {
    pictogram: {
      included: 'https://assets.otto.nl/i/empiriecom/FuAG_included.svg',
      notIncluded: 'https://assets.otto.nl/i/empiriecom/FuAG_not_included.svg',
      specification: 'https://assets.otto.nl/i/empiriecom/FuAG_specifications.svg',
    },
  },
  seoImageParams: '$format_dv_desk_132$',
};
